import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Progress,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Alert,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import { DATA_DISABILITAS_GROUP } from "../utils";
import { logoutUser } from "../actions/AuthAction";

function IndikatorDesa(props) {
  const [dataDisabilitas, setDataDisabilitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewType, setViewType] = useState("kecamatan"); // "kecamatan" atau "desa"
  const [searchTerm, setSearchTerm] = useState("");

  const fetchDataDisabilitas = useCallback(async () => {
    try {
      setLoading(true);
      let endpoint = "";

      if (viewType === "kecamatan") {
        endpoint = `${DATA_DISABILITAS_GROUP}kecamatan`;
      } else {
        endpoint = `${DATA_DISABILITAS_GROUP}desa`;
      }

      const response = await axios.get(endpoint);
      if (response.data.success) {
        setDataDisabilitas(response.data.data);
      } else {
        swal("Gagal", "Gagal mengambil data disabilitas", "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      swal("Gagal", "Gagal mengambil data disabilitas", "error");
    } finally {
      setLoading(false);
    }
  }, [viewType]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      // User data is set but not used in this component
    } else {
      logoutUser(props.history);
    }
    fetchDataDisabilitas();
  }, [props.history, fetchDataDisabilitas]);

  const filteredData = dataDisabilitas.filter(
    (item) =>
      (viewType === "kecamatan"
        ? item.kecamatan?.toLowerCase().includes(searchTerm.toLowerCase())
        : item.desa?.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (viewType === "desa" &&
        item.kecamatan?.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const formatNumber = (num) => {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "0";
  };

  const getProgressColor = (percentage) => {
    if (percentage >= 80) return "success";
    if (percentage >= 60) return "warning";
    return "danger";
  };

  const calculateTotalPercentage = (item) => {
    const total = item.total_disabilitas || 0;
    const sudahRekam = item.sudah_rekam || 0;
    return total > 0 ? Math.round((sudahRekam / total) * 100) : 0;
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  Data Disabilitas per{" "}
                  {viewType === "kecamatan" ? "Kecamatan" : "Desa"}
                </CardTitle>

                {/* Radio Button untuk memilih tampilan */}
                <Row className="mt-3">
                  <Col md="6">
                    <FormGroup tag="fieldset">
                      <legend className="col-form-label col-sm-2">
                        Tampilan Data:
                      </legend>
                      <Col sm={10}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="radio"
                              name="viewType"
                              value="kecamatan"
                              checked={viewType === "kecamatan"}
                              onChange={(e) => setViewType(e.target.value)}
                            />{" "}
                            Per Kecamatan
                          </Label>
                        </FormGroup>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="radio"
                              name="viewType"
                              value="desa"
                              checked={viewType === "desa"}
                              onChange={(e) => setViewType(e.target.value)}
                            />{" "}
                            Per Desa
                          </Label>
                        </FormGroup>
                      </Col>
                    </FormGroup>
                  </Col>

                  {/* Search Bar */}
                  <Col md="6">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="tim-icons icon-zoom-split-in"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder={`Cari berdasarkan ${
                          viewType === "kecamatan" ? "kecamatan" : "desa"
                        }...`}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    <Table className="tablesorter" responsive>
                      <thead className="text-primary">
                        <tr>
                          <th style={{ minWidth: "50px" }}>No</th>
                          {viewType === "kecamatan" ? (
                            <th style={{ minWidth: "200px" }}>Kecamatan</th>
                          ) : (
                            <>
                              <th style={{ minWidth: "200px" }}>Desa</th>
                              <th style={{ minWidth: "200px" }}>Kecamatan</th>
                            </>
                          )}
                          <th style={{ minWidth: "120px" }}>
                            Total Disabilitas
                          </th>
                          <th style={{ minWidth: "100px" }}>Laki-laki</th>
                          <th style={{ minWidth: "100px" }}>Perempuan</th>
                          <th style={{ minWidth: "120px" }}>Sudah Rekam</th>
                          <th style={{ minWidth: "120px" }}>Belum Rekam</th>
                          <th style={{ minWidth: "150px" }}>Progress Rekam</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((item, index) => {
                          const progressPercentage =
                            calculateTotalPercentage(item);
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              {viewType === "kecamatan" ? (
                                <td style={{ fontWeight: "bold" }}>
                                  {item.kecamatan || "-"}
                                </td>
                              ) : (
                                <>
                                  <td style={{ fontWeight: "bold" }}>
                                    {item.desa || "-"}
                                  </td>
                                  <td>{item.kecamatan || "-"}</td>
                                </>
                              )}
                              <td
                                style={{ fontWeight: "bold", color: "#007bff" }}
                              >
                                {formatNumber(item.total_disabilitas)}
                              </td>
                              <td>{formatNumber(item.laki_laki)}</td>
                              <td>{formatNumber(item.perempuan)}</td>
                              <td>
                                <span className="badge badge-success">
                                  {formatNumber(item.sudah_rekam)}
                                </span>
                              </td>
                              <td>
                                <span className="badge badge-warning">
                                  {formatNumber(item.belum_rekam)}
                                </span>
                              </td>
                              <td style={{ width: "30%" }}>
                                <Progress
                                  value={progressPercentage}
                                  color={getProgressColor(progressPercentage)}
                                >
                                  {progressPercentage}%
                                </Progress>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>

                    {!loading && filteredData.length === 0 && (
                      <Alert color="info">
                        {searchTerm
                          ? `Tidak ada data yang sesuai dengan pencarian "${searchTerm}"`
                          : `Belum ada data disabilitas per ${
                              viewType === "kecamatan" ? "kecamatan" : "desa"
                            }`}
                      </Alert>
                    )}

                    {!loading && filteredData.length > 0 && (
                      <div className="mt-3">
                        <small className="text-muted">
                          Menampilkan {filteredData.length} dari{" "}
                          {dataDisabilitas.length} data{" "}
                          {viewType === "kecamatan" ? "kecamatan" : "desa"}
                          {searchTerm && ` (hasil pencarian: "${searchTerm}")`}
                        </small>
                      </div>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default IndikatorDesa;
